import { useParams } from 'react-router-dom'
import { useManualTask } from './useManualTask'

export const useSelectedManualTask = () => {
  const { taskId, notificationId } = useParams<{
    taskId: string
    notificationId: string
  }>()

  const selectedId = taskId ?? notificationId ?? null

  const {
    manualTask: selectedManualTask,
    isPending,
    automationExecutionId
  } = useManualTask({
    taskId: selectedId
  })

  return {
    isPending: !!selectedId && isPending,
    selectedManualTask,
    automationExecutionId
  }
}
